module.exports = __webpack_public_path__ + "img/je.0f59ae9f.svg";